import { render, staticRenderFns } from "./service_sgys.vue?vue&type=template&id=59f08d02"
import script from "./service_sgys.vue?vue&type=script&lang=js"
export * from "./service_sgys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports